// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app[data-v-b08b7cac]{height:100%;min-width:800px}.app[data-v-b08b7cac],.content[data-v-b08b7cac]{width:100%}", ""]);
// Exports
module.exports = exports;
